import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  connect() {
    this.poll()
    this.poller = setInterval(() => this.poll(), 5000)
  }

  disconnect() {
    clearInterval(this.poller)
  }

  async poll() {
    try {
      const response = await fetch(this.urlValue)
      const { ready } = await response.json()

      if (ready) {
        clearInterval(this.poller)
        window.location.reload()
      }
    } catch {
      // ignore network errors
    }
  }
}
